export const menuData = [
	{
		"id": "1559728897740169217",
		"label": "南阳",
		"isLeaf": false,
		"onlineCount": 19,
		"count": 23,
		"children": [{
				"id": "1559737887719075841",
				"label": "1号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570670396317241346",
					"label": "1库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320168117",
					"channelCode": "6",
					"deviceCode": "F65096504",
					"ezvizId": "1719992852546715650"
				}]
			},
			{
				"id": "1559737887878459394",
				"label": "2号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570670779227836418",
					"label": "2库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320168129",
					"channelCode": "19",
					"deviceCode": "G13515883",
					"ezvizId": "1719992852546715650"
				}]
			},
			{
				"id": "1559737887878459395",
				"label": "3号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1570670028246093825",
					"label": "3库",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "34020000001320016818",
					"channelCode": "1",
					"deviceCode": "AA7931469",
					"ezvizId": "1719992852546715650"
				}]
			},
			{
				"id": "1559737887878459397",
				"label": "5号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570670687494213634",
					"label": "5库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320168127",
					"channelCode": "20",
					"deviceCode": "G13515883",
					"ezvizId": "1719992852546715650"
				}]
			},
			{
				"id": "1559737887878459399",
				"label": "8号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570669858955595777",
					"label": "8库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320016815",
					"channelCode": "17",
					"deviceCode": "G13515883",
					"ezvizId": "1719992852546715650"
				}]
			},
			{
				"id": "1570679684020531201",
				"label": "6号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1570679861833854977",
					"label": "6库",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "34020000001320168111"
				}]
			},
			{
				"id": "1559737887878459400",
				"label": "9号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570668882047668225",
					"label": "9库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320000025"
				}]
			},
			{
				"id": "1559737887878459401",
				"label": "10号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1570670613083066370",
					"label": "10库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320168123"
				}]
			},
			{
				"id": "1559737887878459402",
				"label": "11号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1573906314511650817",
					"label": "11库",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "34020000001320168119"
				}]
			},
			{
				"id": "1559737887878459403",
				"label": "12号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1573545605273620482",
					"label": "12库",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "340200000013219216813"
				}]
			},
			{
				"id": "1570680046907518977",
				"label": "烘干门口",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320016814"
			},
			{
				"id": "1570680128021164034",
				"label": "大仓南西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320016816"
			},
			{
				"id": "1570680197600473090",
				"label": "东围墙",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320016817"
			},
			{
				"id": "1570680333277818881",
				"label": "大仓西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168110"
			},
			{
				"id": "1570681826789781506",
				"label": "西围墙",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168112"
			},
			{
				"id": "1570681941575299074",
				"label": "后围墙西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168114"
			},
			{
				"id": "1570682060211187713",
				"label": "后围墙东",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168122"
			},
			{
				"id": "1570682133942857729",
				"label": "大库东",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168116"
			},
			{
				"id": "1570682227161264130",
				"label": "西地磅",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168120"
			},
			{
				"id": "1570682295402590209",
				"label": "大仓南东",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168121"
			},
			{
				"id": "1570682369473998850",
				"label": "大门东",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168124"
			},
			{
				"id": "1570682467889147905",
				"label": "大门西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320168126"
			},
			{
				"id": "1615242554192707585",
				"label": "4号库后",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "31402000000132000002"
			}
		]
	},
	{
		"id": "1559728897920524293",
		"label": "锦宇",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0,
		"children":[]
	},
	{
		"id": "1559728897920524292",
		"label": "宏健",
		"isLeaf": false,
		"onlineCount": 16,
		"count": 27,
		"children": [{
				"id": "1559737888008482831",
				"label": "8号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 2,
				"children": [{
						"id": "1560527631503765513",
						"label": "8号仓西北向南",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001320001171"
					},
					{
						"id": "1560527631503765514",
						"label": "8号仓东南向北",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001320001181"
					}
				]
			},
			{
				"id": "1559737888008482832",
				"label": "9号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1560527631503765515",
					"label": "9号仓西北向南",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "34020000001320001191"
				}]
			},
			{
				"id": "1559737888008482833",
				"label": "16号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1560527631503765512",
					"label": "16号仓东南向西",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320001081"
				}]
			},
			{
				"id": "1559737888008482834",
				"label": "17号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 1,
				"children": [{
					"id": "1560527631503765520",
					"label": "17号仓东南向西",
					"isLeaf": true,
					"online": false,
					"onlineCount": 0,
					"count": 1,
					"sn": "34020000001320001101"
				}]
			},
			{
				"id": "1559737888071397377",
				"label": "18号仓",
				"isLeaf": false,
				"onlineCount": 2,
				"count": 2,
				"children": [{
						"id": "1560527631503765511",
						"label": "18号仓东南向西",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320001121"
					},
					{
						"id": "1560527631503765518",
						"label": "18号仓西北向东",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320001111"
					}
				]
			},
			{
				"id": "1559737888071397381",
				"label": "23号仓",
				"isLeaf": false,
				"onlineCount": 2,
				"count": 2,
				"children": [{
						"id": "1560527631503765516",
						"label": "23号仓东北向西",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320001151"
					},
					{
						"id": "1560527631503765517",
						"label": "23号仓西南向东",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320001161"
					}
				]
			},
			{
				"id": "1559737888071397382",
				"label": "24号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 2,
				"children": [{
						"id": "1560527631281467393",
						"label": "24号仓东门",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320002251"
					},
					{
						"id": "1560527631369547777",
						"label": "24号仓南门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001320002261"
					}
				]
			},
			{
				"id": "1559737888071397384",
				"label": "26号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 2,
				"children": [{
						"id": "1560527631369547780",
						"label": "26号仓南门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001320002291"
					},
					{
						"id": "1560527631369547781",
						"label": "26号仓西门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001320002301"
					}
				]
			},
			{
				"id": "1559737888071397385",
				"label": "27号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1560527631436656641",
					"label": "27号仓东门",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320002311"
				}]
			},
			{
				"id": "1559737888071397386",
				"label": "28号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1560527631436656644",
					"label": "28号仓西门",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001320002341"
				}]
			},
			{
				"id": "1559737888071397387",
				"label": "29号仓",
				"isLeaf": false,
				"onlineCount": 2,
				"count": 2,
				"children": [{
						"id": "1560527631436656645",
						"label": "29号仓东门",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320002351"
					},
					{
						"id": "1560527631436656646",
						"label": "29号仓北门",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320002361"
					}
				]
			},
			{
				"id": "1559737888071397388",
				"label": "30号仓",
				"isLeaf": false,
				"onlineCount": 2,
				"count": 2,
				"children": [{
						"id": "1560527631436656647",
						"label": "30号仓东北门",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320002371"
					},
					{
						"id": "1560527631436656648",
						"label": "30号仓西北门",
						"isLeaf": true,
						"online": true,
						"onlineCount": 1,
						"count": 1,
						"sn": "34020000001320002381"
					}
				]
			},
			{
				"id": "1560527631570874369",
				"label": "27号仓东南向西",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "34020000001320000641"
			},
			{
				"id": "1560527631570874371",
				"label": "9号仓东北向西",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "34020000001320000381"
			},
			{
				"id": "1560527631570874377",
				"label": "22号仓东墙向南",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320000311"
			},
			{
				"id": "1560527631570874380",
				"label": "29号仓东北向西",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "34020000001320000351"
			},
			{
				"id": "1560527631637983233",
				"label": "16号仓东南向西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320002471"
			},
			{
				"id": "1560527631637983234",
				"label": "29号仓东墙向南",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "34020000001320000361"
			},
			{
				"id": "1560527631637983235",
				"label": "16号仓东北向西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320002481"
			},
			{
				"id": "1560527631637983240",
				"label": "32号仓西北向西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320001221"
			}
		]
	},
	{
		"id": "1559728897920524291",
		"label": "洋心洼",
		"isLeaf": false,
		"onlineCount": 3,
		"count": 3,
		"children": [{
				"id": "1559737888008482829",
				"label": "14号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1571834382807130114",
					"label": "14号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001321111133"
				}]
			},
			{
				"id": "1571833798100180993",
				"label": "大门里",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001321111125"
			},
			{
				"id": "1571834541221797890",
				"label": "大门西",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001321111135"
			}
		]
	},
	{
		"id": "1559728897920524290",
		"label": "通商",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1559728897857609729",
		"label": "万盈",
		"isLeaf": false,
		"onlineCount": 9,
		"count": 9,
		"children": [{
				"id": "1559737887941373956",
				"label": "2号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573139822241292290",
					"label": "2号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168114"
				}]
			},
			{
				"id": "1559737887941373957",
				"label": "4号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573138928560939010",
					"label": "4号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168116"
				}]
			},
			{
				"id": "1559737887941373959",
				"label": "6号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573140044971417601",
					"label": "6号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168118"
				}]
			},
			{
				"id": "1559737887941373960",
				"label": "7号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573139715227820034",
					"label": "7号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168113"
				}]
			},
			{
				"id": "1559737887941373962",
				"label": "9号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573139134400602113",
					"label": "9号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168112"
				}]
			},
			{
				"id": "1559737887941373963",
				"label": "10号仓",
				"isLeaf": false,
				"onlineCount": 1,
				"count": 1,
				"children": [{
					"id": "1573139245377691649",
					"label": "10号库",
					"isLeaf": true,
					"online": true,
					"onlineCount": 1,
					"count": 1,
					"sn": "34020000001192168109"
				}]
			},
			{
				"id": "1574226829315076098",
				"label": "大门口",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320000117"
			},
			{
				"id": "1574226950836645890",
				"label": "四五仓门口",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320000012"
			},
			{
				"id": "1574579285102346241",
				"label": "库区二道门",
				"isLeaf": true,
				"online": true,
				"onlineCount": 1,
				"count": 1,
				"sn": "34020000001320000018"
			}
		]
	},
	{
		"id": "1561600215800520706",
		"label": "焦点",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1572392426955771906",
		"label": "遵义",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 12,
		"children": [{
				"id": "1572403339054190593",
				"label": "5号仓",
				"isLeaf": false,
				"onlineCount": 0,
				"count": 8,
				"children": [{
						"id": "1573234113584222210",
						"label": "5号6号仓后门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "3402000000192168164"
					},
					{
						"id": "1573234513641132034",
						"label": "5号仓库前门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "3402000000192168112"
					},
					{
						"id": "1573235247682080770",
						"label": "5号仓库1",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "340200000019216818"
					},
					{
						"id": "1573235424539103233",
						"label": "5号仓库2",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "340200000019216816"
					},
					{
						"id": "1573235501877874690",
						"label": "5号6号仓库后门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "340200000019216815"
					},
					{
						"id": "1573235572266684417",
						"label": "5号6号仓库前面",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "34020000001921681200"
					},
					{
						"id": "1573235648527519745",
						"label": "5号仓库3",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "340200000019216812"
					},
					{
						"id": "1573235709588197377",
						"label": "5号6号中间库门",
						"isLeaf": true,
						"online": false,
						"onlineCount": 0,
						"count": 1,
						"sn": "3402000000192168160"
					}
				]
			},
			{
				"id": "1573234999681273858",
				"label": "6号仓库1",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "3402000000192168111"
			},
			{
				"id": "1573235059974393857",
				"label": "6号仓库前门",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "3402000000192168110"
			},
			{
				"id": "1573235130296094721",
				"label": "6仓库2",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "340200000019216819"
			},
			{
				"id": "1573235319278850050",
				"label": "6号仓库3",
				"isLeaf": true,
				"online": false,
				"onlineCount": 0,
				"count": 1,
				"sn": "340200000019216817"
			}
		]
	},
	{
		"id": "1592436932828647426",
		"label": "和顺祥",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1592446106803294210",
		"label": "鑫惠",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1592447843719106561",
		"label": "魏军粮食",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1592450286481756162",
		"label": "旺福益",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1597893108294914049",
		"label": "权德粮油",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1669650190925086721",
		"label": "尚庄粮库",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1700049679157788674",
		"label": "1号库-米",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1700053089894498305",
		"label": "1号库-面",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	},
	{
		"id": "1700053169745657857",
		"label": "1号库-油",
		"isLeaf": false,
		"onlineCount": 0,
		"count": 0
	}
]